import {
  Box,
  Button,
  Divider,
  IconButton,
  Stack,
  Typography,
} from "@mui/material";
import { FieldArray } from "react-final-form-arrays";
import { CfiItem } from "../cfiTypes";
import MuiDelete from "@mui/icons-material/Delete";
import { MuiAdd } from "../../common/icons";
import { ItemFields } from "./ItemFields";
import { DEFAULT_ITEM_VALUES } from "./ItemFieldsList";

export interface ItemSectionProps {
  title: string;
  name: string;
}

export function ItemSection({ title, name }: ItemSectionProps) {
  return (
    <Box>
      <Box
        pb={1}
        bgcolor="primary.main"
        color="primary.contrastText"
        py={1}
        px={3}
      >
        <Typography variant="h6">{title}</Typography>
      </Box>
      <Box border={1} borderColor="divider" borderRadius={1} p={2}>
        <FieldArray<CfiItem>
          name={name}
          render={({ fields }) => (
            <>
              <Stack gap={2} divider={<Divider />}>
                {fields.map((itemName, index) => (
                  <Stack
                    key={itemName}
                    direction="row"
                    alignItems="center"
                    gap={1}
                  >
                    <ItemFields namespace={itemName} />
                    {(fields.length ?? 0) > 1 && (
                      <IconButton
                        color="error"
                        aria-label={`Remove ${title} item ${index + 1}`}
                        onClick={() => fields.remove(index)}
                      >
                        <MuiDelete />
                      </IconButton>
                    )}
                  </Stack>
                ))}
              </Stack>
              <Box ml={5} mt={2}>
                <Button
                  startIcon={<MuiAdd />}
                  variant="outlined"
                  onClick={() => fields.push({ ...DEFAULT_ITEM_VALUES })}
                >
                  Add Item
                </Button>
              </Box>
            </>
          )}
        />
      </Box>
    </Box>
  );
}
